import React, { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";

const LotContext = createContext({ lotType: "dacia", isPackMultimedia: false });

export const LotProvider = ({ children }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const lotType = params.get("lot") === "pm" ? "pm" : "dacia";
  const isPackMultimedia = lotType === "pm";

  return (
    <LotContext.Provider value={{ lotType, isPackMultimedia }}>
      {children}
    </LotContext.Provider>
  );
};

export const useLot = () => useContext(LotContext);
